document.addEventListener('change', function (event) {
  const selector = event.target.closest('[data-card-variant-selector]');
  if (!selector) return;

  const card = selector.closest('[data-product-card-root]');
  if (!card) return;

  const selectedOption = selector.options[selector.selectedIndex];
  if (!selectedOption) return;

  const price = selectedOption.dataset.price || '';
  const compareAtPrice = selectedOption.dataset.compareAtPrice || '';
  const discountPercentage = selectedOption.dataset.discountPercentage || '';
  const available = selectedOption.dataset.available === 'true';

  const priceContainer = card.querySelector('[data-card-price-wrapper] .price');
  const regularPrice = card.querySelector('[data-card-price-wrapper] .price__regular .price-item--regular');
  const salePrice = card.querySelector('[data-card-price-wrapper] .price__sale .price-item--sale');
  const comparePrice = card.querySelector('[data-card-price-wrapper] .price__sale .price-item--regular');
  const discountPrice = card.querySelector('[data-card-price-wrapper] [data-price-discount]');
  const submitButton = card.querySelector('[data-card-variant-submit]');
  const buttonText = card.querySelector('[data-card-variant-button-text]');

  if (regularPrice) regularPrice.textContent = price;
  if (salePrice) salePrice.textContent = price;
  if (comparePrice) comparePrice.textContent = compareAtPrice;

  if (discountPrice) {
    discountPrice.textContent = discountPercentage
      ? `-${discountPercentage}% OFF`
      : '';

    discountPrice.hidden = !discountPercentage;
  }

  if (priceContainer) {
    priceContainer.classList.toggle('price--on-sale', Boolean(compareAtPrice));
    priceContainer.classList.toggle('price--sold-out', !available);
  }

  if (submitButton) submitButton.disabled = !available;

  if (buttonText) {
    buttonText.textContent = available
      ? window.productCardStrings.addToCart
      : window.productCardStrings.soldOut;
  }
});